<template>
  <div class="newsDetail">
    <nav-bar
      fixed
      z-index="99"
      :title="articleInfo.title"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="title">{{ articleInfo.title }}</div>
    <div class="conter" v-html="articleInfo.content"></div>
  </div>
</template>
<script>
import { getViewDetails } from "@api/public";
import { NavBar } from "vant";
export default {
  name: "NewsDetail",
  components: {NavBar},
  props: {},
  data: function () {
    return {
      articleInfo: {},
    };
  },
  watch: {
    $route(to) {
      if (to.name === "NewsDetail") this.articleDetails();
    },
  },
  mounted: function () {
    this.articleDetails();
  },
  methods: {
    updateTitle() {
      document.title = this.articleInfo.title || this.$route.meta.title;
    },
    articleDetails: function () {
      let that = this,
        id = this.$route.params.id;
      getViewDetails(id).then((res) => {
        that.articleInfo = res.data;
        that.updateTitle();
      });
    },
  },
};
</script>
